/*
 * @Author: zxf
 * @Date: 2022-07-20 14:23:00
 * @LastEditors: cws
 * @LastEditTime: 2022-09-30 16:41:56
 * @Description: 维保计划管理服务
 */
import axios from 'axios';
import config from '@/config';

const { iffApi } = config.ctx;
export const wbjhxqService = {

  // 生成临时报告
  generateTempReport: (id) => { return axios.get(`${iffApi}/xfwb/wbjh/wbbg/lsbg/${id}`); },

  // 生成正式报告
  generateReport: (params) => { return axios.get(`${iffApi}/xfwb/wbjh/wbbg/zsbg`, { params: params }); },

  // 导出
  export: (params) => { return axios.get(`${iffApi}/wbjh/tj/export`, { responseType: 'blob', params }); }

};
